import React, { Component } from 'react';
import { changeTipoFigura } from '../libs/utils/GlobalFunc';



const renderTableBody = (headers, data, checkbox, openDetails) => {
    let body = "";

    body = data.map((register, index) => {
        if (register.statusBorrador != 'W' && register.statusBorrador != 'Y') {
            return (
                <tr key={index}>
                    {headers[0].value && <td className="dataTables-body-center">{register.CodigoFiguraTransporte}</td>}
                    {headers[1].value && <td className="dataTables-body-center">{changeTipoFigura(register.TipoFigura.trim())}</td>}
                    {headers[2].value && <td className="dataTables-body-center">{register.NombreFigura}</td>}
                    {headers[3].value && <td className="dataTables-body-center">{register.RFC}</td>}
                    {headers[4].value && <td className="dataTables-body-center">{register.NumLicencia}</td>}
                    {headers[5].value && <td className="dataTables-body-center">{register.CodigoPostal}</td>}
                    {headers[6].value && <td className="dataTables-body-center">{register.Pais}</td>}
                    <td className="sticky-columns dataTables-body-center" style={{ backgroundColor: "#e9ecef" }}>
                        <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                            onClick={() => openDetails({ Code: register.CodigoFiguraTransporte, index })}
                            style={{ fontWeight: '500' }}>
                            <i className="far fa-file-alt">
                            </i> Ver Detalles
                        </button>
                    </td>
                </tr>
            )
        }
    })
    return body;
};

const renderTable = (headers, data, checkbox, openDetails) => {
    let header = "";
    let body = "";

    if (headers.length != 0) {
        header = <tr>
            {headers[0].value && <td className="dataTables-header-center">{headers[0].title}</td>}
            {headers[1].value && <td className="dataTables-header-center">{headers[1].title}</td>}
            {headers[2].value && <td className="dataTables-header-center">{headers[2].title}</td>}
            {headers[3].value && <td className="dataTables-header-center">{headers[3].title}</td>}
            {headers[4].value && <td className="dataTables-header-center">{headers[4].title}</td>}
            {headers[5].value && <td className="dataTables-header-center">{headers[5].title}</td>}
            {headers[6].value && <td className="dataTables-header-center">{headers[6].title}</td>}
            <td className="sticky-columns dataTables-header-center" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>

        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;
    return table;

};

export const renderFiguraTransporte = (headers, data, checkbox, openDetails) => {

    return renderTable(headers, data, checkbox, openDetails);

}